import * as React from 'react';
const ModalContent = (props) => {
    const { children, className } = props;
    const BEM = () => {
        const classArray = ['modal__body'];
        if (className) {
            classArray.push(className);
        }
        return classArray.join(' ');
    };
    return React.createElement("div", { className: BEM() }, children);
};
export default ModalContent;
